import { useTranslation } from 'react-i18next';
import Style from './GroupInfoUserInput.module.css';

const GroupInfoUserInput = ({ inputValue, setInputGrouNameValue, dynamicWidth, handleSubmit }) => {
  const { t } = useTranslation();
  const inputWidth = inputValue.length * 3 + dynamicWidth;

  return (
    <div className={Style.inputContainer}>
      <input
        autoFocus={true}
        type='text'
        value={inputValue}
        onChange={e => setInputGrouNameValue(e.target.value)}
        className={Style.input}
        style={{ width: inputWidth }}
        placeholder={t('screens.chat.enterGroupName')}
      />
      {inputValue.length > 0 && (
        <svg onClick={() => handleSubmit()} style={{ marginLeft: '-1.4rem', marginTop: '-0.4rem' }} className={Style.group_name_edit_icon}>
          <use xlinkHref={`/assets/sprite.svg#icon-group-name-save`} />
        </svg>
      )}
    </div>
  );
};

export default GroupInfoUserInput;
